module.exports = __webpack_public_path__ + "img/Admin_plus_kiosk_logo.adf9ead7.svg";